var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 18,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6781 5.48633C15.187 5.48633 13.8545 6.25918 13.8545 7.68709C13.8545 9.32464 16.2177 9.43774 16.2177 10.2604C16.2177 10.6068 15.8208 10.9169 15.1428 10.9169C14.1806 10.9169 13.4614 10.4836 13.4614 10.4836L13.1537 11.9245C13.1537 11.9245 13.9822 12.2905 15.0821 12.2905C16.7123 12.2905 17.9951 11.4797 17.9951 10.0274C17.9951 8.297 15.622 8.18725 15.622 7.42369C15.622 7.15235 15.9479 6.85504 16.6239 6.85504C17.3867 6.85504 18.009 7.17014 18.009 7.17014L18.3102 5.77845C18.3102 5.77845 17.633 5.48633 16.6781 5.48633ZM3.03611 5.59136L3 5.80143C3 5.80143 3.6273 5.91623 4.19229 6.14525C4.91975 6.40785 4.97158 6.56073 5.09409 7.03556L6.42916 12.1822H8.21882L10.9759 5.59136H9.19037L7.41876 10.0725L6.69584 6.27407C6.62954 5.83935 6.29372 5.59136 5.88266 5.59136H3.03611ZM11.6939 5.59136L10.2932 12.1822H11.9959L13.3917 5.59136H11.6939ZM21.1904 5.59136C20.7798 5.59136 20.5623 5.81118 20.4026 6.1953L17.9081 12.1822H19.6937L20.0391 11.1844H22.2144L22.4245 12.1822H24L22.6255 5.59136H21.1904ZM21.4226 7.372L21.9519 9.84519H20.5339L21.4226 7.372Z",
    fill: "#1434CB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 17,
    rx: 1.5,
    stroke: "black",
    strokeOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.dab7ba069cf10fbc839c3be9f16ce742.svg";
export { ForwardRef as ReactComponent };